import type { PropsWithChildren, ReactNode } from 'react';

type CouponAdditionsProps = PropsWithChildren;

/**
 * Container for all the additions cards/items.
 *
 * @param root0 the input object
 * @param root0.children the cards with additions.
 * @returns Component
 */
export default function CouponAdditions({ children }: CouponAdditionsProps): ReactNode {
  return <div className="box-border flex flex-col flex-wrap justify-center gap-4 lg:flex-row">{children}</div>;
}
